import '../scss/main.scss';
import Scroller from './Scroller.svelte';
import HeaderChart from './HeaderChart.svelte';
import data from 'Locales/en/data.json';
import staticData from '../static/data/staticData.json';
import fccData from '../static/data/fcc.json';
import GraphicFCC from './Spectrum.svelte';
import { uniqueSort } from 'jquery';
import { QuickSight } from 'aws-sdk'; // new GraphicFCC({
//   target: document.querySelector('.graphic-spectrum'),
//   props: {
//     allData: staticData,
//   },
// })
//   ;
// new Scroller({
//   target: document.querySelector('.graphic-spectrum'),
//   props: {
//     googleDoc: googleDoc,
//     allData: staticData,
//   },
// });

/*
let formatter = require('d3-format');
let d3 = Object.assign(
  formatter,
  require('d3-fetch'),
  require('d3-time-format')
);
window.jQuery = window.$ = require('jquery');

import ReutersCharter from 'ReutersCharter';
*/

/*
import(`Locales/${locale}/myDoc.json`).then((doc) => {

});

const data = require(`../../locales/en/text.json`);

*/

var googleDoc = require('../../locales/en/text.json');

staticData.nestedData = fccData.entries; // IF we're in an iframe...

var isEmbedded = window.location !== window.parent.location; // You can write code specific to embeds like this...

if (isEmbedded) {
  try {
    window.childFrame.sendHeight();
  } catch (err) {
    console.log('pym not found.');
  }
} // new HeaderChart({
//   target: document.querySelector('.header-chart'),
//   props: {
//     data: data.wifi,
//   },
// });


var fullData = Object.assign({}, staticData, {
  nestedData: fccData.entries
});
var scrollBlocks = googleDoc.blocks.filter(function (d) {
  return d.Type == 'scroll';
}); // new GraphicFCC({
//   target: document.querySelector('.graphic-spectrum'),
//   props: {
//     googleDoc: scrollBlocks[0],
//     allData: fullData,
//     type: 'bands',
//   },
// });
// new GraphicFCC({
//   target: document.querySelector('.graphic-spectrum'),
//   props: {
//     googleDoc: scrollBlocks[1],
//     type: 'spectrum',
//     allData: fullData,
//   },
// });

new Scroller({
  target: document.querySelector('#scroll-1'),
  props: {
    googleDoc: scrollBlocks[0],
    type: 'bands',
    allData: fullData
  }
});
new Scroller({
  target: document.querySelector('#scroll-2'),
  props: {
    googleDoc: scrollBlocks[1],
    type: 'spectrum',
    allData: fullData
  }
});
import Header from './Header.svelte';
new Header({
  target: document.querySelector('.headerAnim')
});